module.exports = __webpack_public_path__ + "img/download-file-csv.27cec280.svg";